import { AccountConfigData } from "~/backend/generated/Configuration/model/accountConfigData";
import { accountConfigProvider } from "../AccountConfigProvider/AccountConfigProvider";
import { AccountConfigOptions } from "../AccountConfigOptions/AccountConfigOptions";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export const getAccountConfigData = async (
    sessionToken: string,
    options?: AccountConfigOptions
): Promise<AccountConfigData> => {
    return accountConfigProvider(ContextManager.newInstance())(sessionToken, options);
};
